<template>
  <div class="container-fluid">
    <h6 class="font-weight-bold text-center">Nova Venda</h6>
    <hr>
    <div class="row no-gutters pt-2 mb-3">
      <div class="col-6 p-1">
        <a id="btnVendaRapida" class="btn btn-third btn-block py-3 text-left" href="javascript:" @click="$emit('novaVenda', 1)">
          <div class="small">
            <icon-sys name="fast"/>
            <div>Venda Rápida (Alt+1)</div>
          </div>
        </a>
      </div>
      <div class="col-6 p-1">
        <a id="btnDelivery" class="btn btn-secondary btn-block py-3 text-left" href="javascript:" @click="$emit('novaVenda', 2)">
          <div class="small">
            <icon-sys name="delivery"/>
            <div>Delivery (Alt+2)</div>
          </div>
        </a>
      </div>
      <div class="col-6 p-1">
        <a href="javascript:" id="btnMesa" class="btn btn-info btn-block py-3 text-left" @click="$emit('openModal', 1)">
          <div class="small">
            <icon-sys name="table"/>
            <div>Mesas (Alt+3)</div>
          </div>
        </a>
      </div>
      <div class="col-6 p-1">
        <a href="javascript:" id="btnComanda" class="btn btn-success btn-block py-3 text-left" @click="$emit('openModal', 3)">
          <div class="small">
            <icon-sys name="comanda"/>
            <div>Comandas (Alt+4)</div>
          </div>
        </a>
      </div>
      <div class="col-12 p-1">
        <a href="javascript:" id="btnPesquisar" class="btn btn-dark btn-block py-3 text-left" @click="$emit('openModal', 5)">
          <div class="text-center">
            <icon-sys name="search"/>
            <div>Pesquisar Venda (Alt+5)</div>
          </div>
        </a>
      </div>
    </div>
    <div class="border rounded p-3 small mb-3">
      <i class="fa fa-info-circle"></i> A Venda Rápida não gera pedidos para cozinha
    </div>
  </div>
</template>

<script>
  import IconSys from "../../../components/pdv/IconSys";
  export default {
    name: "NovaVenda",
    components: {IconSys},
    mounted() {
      this.$helpers.focusElement('btnVendaRapida');
    }
  }
</script>

<style scoped>

</style>
